module.exports = __WEBPACK_EXTERNAL_MODULE_https_esm_sh_react_dom_19_3_0_canary_bcf97c75_20251215_baf0f20e__;